import { AnimatePresence, motion } from 'framer-motion';
import React, { FC, PropsWithChildren, useEffect, useState } from 'react';
import { disableScrollLock, enableScrollLock } from "@montana/helpers/scroll-lock.helper";
import { Portal } from '../portal';
import { useRouter } from '@montana/containers/router';

type Props = {
    open: boolean;
    onDismiss: () => void;
}

export const SidePanel: FC<PropsWithChildren<Props>> = ({open, onDismiss, children}) => {
    const [internalOpen, setInternalOpen] = useState(open);
    const { location } = useRouter();

    useEffect(() => {
        setInternalOpen(false);
    }, [location]);

    useEffect(() => {
        setInternalOpen(open)
        open ? enableScrollLock() : disableScrollLock();
    }, [open])

    if (!open) {
        return <></>
    }

    return (
        <Portal>
            <div className="side-panel">
                <AnimatePresence onExitComplete={() => onDismiss()}>
                    {internalOpen && (
                        <motion.div className="side-panel__overlay"
                            key="side-panel__overlay"
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            exit={{ opacity: 0 }}
                            onClick={() => setInternalOpen(false)}
                        />
                    )}
                    {internalOpen && (
                        <motion.div className="side-panel__content"
                            key="side-panel__content"
                            initial={{ y: '-100%' }}
                            animate={{ y: 0 }}
                            exit={{ y: '-100%' }}
                            transition={{ duration: 0.3 }}
                        >
                            <motion.div className="side-panel__content"
                                key="side-panel__content"
                                initial={{ opacity: 0 }}
                                animate={{ opacity: 1 }}
                                exit={{ opacity: 0 }}
                                transition={{ duration: 0.5 }}
                            >
                                <div className="side-panel__content-inner">
                                    {children}
                                </div>
                            </motion.div>
                        </motion.div>
                    )}
                </AnimatePresence>
            </div>
        </Portal>
    )
}
